// Error class used to detect and handle custom authentication errors
export default class UnauthenticatedError extends Error {
    //NOP
}
